import * as React from 'react';

// Components
import PageGeneric from '../PageGeneric';

// Styles
import styles from './style.scss';

export default function PageUser({
  enableBackgroundColor = true,
}: {
  enableBackgroundColor?: boolean;
}) {
  return (
    <PageGeneric
      className={styles.container}
      shouldHideNavbarInDesktop={true}
      enableBackgroundColor={enableBackgroundColor}
    />
  );
}
